<template>
  <div
    :class="[bgWhite?'bg-white':'']"
    :style="{height:statusbarHeight+'px'}"
  />
</template>
<script>
/**
 * 针对APP 全屏显示做的处理
 * 此组件 是为了补充页面高度 及 手机顶部状态栏的高度 （电量 wifi 信号 时间等）
 * */
import { isH5 ,getStatusbarHeight,setStatusBarStyle} from 'CommonUtils/plus'

export default {
  name:'LdStatusbar',
  props:{
    bgWhite:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      statusbarHeight:0
    }
  },
  created(){

  },
  mounted(){
    if(isH5()==false){
      this.statusbarHeight=getStatusbarHeight()
      if(this.bgWhite){
        setStatusBarStyle('dark')
      }else{
        setStatusBarStyle('light')
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>